import React from 'react';

interface EmailLinkProps {
  user: string;
  domain: string;
  className?: string;
}

const EmailLink: React.FC<EmailLinkProps> = ({ user, domain, className = 'text-blue-600 hover:underline' }) => {
  const handleMailClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Reconstruction de l'email au moment du clic uniquement
    const email = `${user}@${domain}`;
    window.location.href = `mailto:${email}`;
  };

  return (
    <a href={`#contact-${user}`} onClick={handleMailClick} className={className}>
      {user}@{domain}
    </a>
  );
};

export default EmailLink;
